import { Component } from 'react';

// Si una pantalla falla, enseña el error en vez de dejarla en blanco
export default class Fallo extends Component {
  constructor(p) { super(p); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidUpdate(prev) { if (prev.ruta !== this.props.ruta && this.state.error) this.setState({ error: null }); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="tarjeta">
        <h3>Algo ha fallado en esta pantalla</h3>
        <p className="tenue">Mándale una captura de esto a Claude:</p>
        <pre style={{ whiteSpace: 'pre-wrap', fontSize: '.8rem' }}>{String(this.state.error?.stack || this.state.error).slice(0, 1500)}</pre>
        <button className="btn sec" onClick={() => this.setState({ error: null })}>Reintentar</button>
      </div>
    );
  }
}
